import { TAGS, api } from "store/api"
import { IPaginationReq } from "utils/interfaces"
import {
  IBossLeaderboardPlayers,
  IBossLeaderboardPersonalReward,
  IBossLeaderboardClansReward,
  IBossLeaderboardClans,
  IBossLeaderboardPlayersItem
} from "./types"

export const bossClansAPI = api.enhanceEndpoints({
  addTagTypes: [TAGS.BOSS_LEADERBOARD]
})

export const bossClansEndpoints = bossClansAPI.injectEndpoints({
  endpoints: (builder) => ({
    getBossLeaderboardPlayers: builder.query<
      IBossLeaderboardPlayers,
      IPaginationReq & { seasonIndex: number; league?: number }
    >({
      query: ({ league, ...rest }) => ({
        url: `/boss/leaderboard/personal`,
        method: "GET",
        params: {
          ...rest,
          ...(league !== undefined && { league })
        }
      }),
      providesTags: (_, __, params) => [
        { type: TAGS.BOSS_LEADERBOARD, id: "LEADERBOARD_PERSONAL" },
        {
          type: TAGS.BOSS_LEADERBOARD,
          id: `LEADERBOARD_PERSONAL:page:${params.page}:limit:${params.limit}`
        }
      ]
    }),
    getBossLeaderboardPersonalReward: builder.query<
      IBossLeaderboardPersonalReward,
      { league?: number } | void
    >({
      query: (arg) => {
        const league = arg && "league" in arg ? arg.league : undefined
        return {
          url: `/boss/rewards/personal`,
          method: "GET",
          params: league !== undefined ? { league } : undefined
        }
      },
      providesTags: (_, __, arg) => [
        {
          type: TAGS.BOSS_LEADERBOARD,
          id: `LEADERBOARD_PERSONAL_REWARD:${
            arg && "league" in arg ? arg.league : "default"
          }`
        },
        { type: TAGS.BOSS_LEADERBOARD, id: "LEADERBOARD_PERSONAL_REWARD" }
      ]
    }),
    getBossLeaderboardClans: builder.query<
      IBossLeaderboardClans,
      IPaginationReq & { seasonIndex: number }
    >({
      query: (params) => ({
        url: `/boss/leaderboard/clan`,
        method: "GET",
        params
      }),
      providesTags: (_, __, params) => [
        { type: TAGS.BOSS_LEADERBOARD, id: "LEADERBOARD_CLANS" },
        {
          type: TAGS.BOSS_LEADERBOARD,
          id: `LEADERBOARD_CLANS:page:${params.page}:limit:${params.limit}`
        }
      ]
    }),
    getBossLeaderboardClansReward: builder.query<
      IBossLeaderboardClansReward,
      void
    >({
      query: () => ({
        url: `/boss/rewards/clan`,
        method: "GET"
      }),
      providesTags: [
        { type: TAGS.BOSS_LEADERBOARD, id: "LEADERBOARD_CLANS_REWARD" }
      ]
    }),
    getBossLeaderboardSeasonsCount: builder.query<{ count: number }, void>({
      query: () => ({
        url: `/boss/seasons/count`,
        method: "GET"
      }),
      providesTags: [
        { type: TAGS.BOSS_LEADERBOARD, id: "LEADERBOARD_SEASONS_COUNT" }
      ]
    }),
    getBossLeaderboardUserById: builder.query<
      IBossLeaderboardPlayersItem,
      string
    >({
      query: (userId) => ({
        url: `/boss/leaderboard/user/${userId}`,
        method: "GET"
      }),
      providesTags: (_, __, userId) => [
        { type: TAGS.BOSS_LEADERBOARD, id: `LEADERBOARD_USER:${userId}` }
      ]
    })
  })
})
